export default __webpack_public_path__ + "static/media/remote.22bde608.jpg";